import { useState } from "react";

import useData from "./useData";
import usePage from "./usePage";

const useExpenseAccount = () => {
  const { getFromServer, updateRecord, deleteRecord } = useData();
  const { showMessage } = usePage();

  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadExpenseAccounts = async () => {
    setLoading(true);
    try {
      const results = await getFromServer({ entityName: "ExpenseAccount" });
      const rows = Array.isArray(results) ? results : [];
      setExpenseAccounts(rows);
      return rows;
    } finally {
      setLoading(false);
    }
  };

  const saveExpenseAccount = async (data) => {
    const payload = {
      ...data,
      name: data?.name ? String(data.name).trim() : "",
      name_fr: data?.name_fr ? String(data.name_fr).trim() : "",
      type: data?.type ? String(data.type).toLowerCase().trim() : "expense",
      glAccount: data?.glAccount ? String(data.glAccount).trim() : "",
      sortOrder: Number.isFinite(Number(data?.sortOrder))
        ? Number(data.sortOrder)
        : 0,
      isActive: data?.isActive !== false,
    };

    const response = await updateRecord("ExpenseAccount", payload, false);
    if (!response?.isSuccessful) {
      showMessage(
        response?.message || "Failed to save expense account",
        "error",
      );
      return false;
    }

    showMessage("saved", "success");
    await loadExpenseAccounts();
    return true;
  };

  const removeExpenseAccount = async (id) => {
    try {
      await deleteRecord("ExpenseAccount", id);
      showMessage("removed", "success");
      await loadExpenseAccounts();
      return true;
    } catch (err) {
      showMessage(err.message, "error");
      return false;
    }
  };

  return {
    loading,
    expenseAccounts,
    loadExpenseAccounts,
    saveExpenseAccount,
    removeExpenseAccount,
  };
};

export default useExpenseAccount;
